import { useEffect as t } from "react";
const e = (e2, c) => {
  const n = (t2) => {
    e2.current && !e2.current.contains(t2.target) && c();
  };
  t(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
export {
  e as useClickOutside
};
//# sourceMappingURL=useClickOutside.js.map
